import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  icon: {
    flexShrink: 0,
    '--icon__primary__stroke__color': 'var(--card--text__color)',
    marginRight: '6px'
  },
  text: {
    background: 'var(--primary__page__background)',
    fontFamily: ({ index }) => index === 0 ? 'BentonSansBold' : 'BentonSansRegular'
  },
  wrapper: {
    alignItems: 'baseline',
    background: 'var(--primary__page__background__color)',
    display: 'flex',
    padding: '0px 10px 5px 20px',
    '&:last-child': {
      paddingBottom: '0px'
    }
  }
})

export default useStyles
